import { styled } from '@mui/material/styles';

type Props = {
  height?: string | number;
  color?: string;
};
export const VerticalDivider = styled('div')<Props>(
  ({ theme, height = '100%', color = theme.palette.divider }) => ({
    width: 1,
    minWidth: 1,
    height,
    backgroundColor: color,
  }),
);
